export default "__VITE_ASSET__40b4b3eb__"